import httpbaseURL from "../../../../modules/Inventory/common/axios";
class EscalationService {
  createdata(doc) {
    return httpbaseURL.httpMSInventoryUrl.post("/AssetEscalation/Create", doc);
  }
  updatedata(doc) {
    return httpbaseURL.httpMSInventoryUrl.post("/AssetEscalation/Update", doc);
  }
  getdata() {
    return httpbaseURL.httpMSInventoryUrl.get("/AssetEscalation/List");
  }
  getfindonedata(doc) {
    return httpbaseURL.httpMSInventoryUrl.get("/AssetEscalation/Get?id=" + doc);
  }

  getEscalationByMaintanenceId(doc) {
    return httpbaseURL.httpMSInventoryUrl.get(
      "/AssetEscalation/GetEscalationByMaintanenceId?id=" + doc
    );
  }
  updateStatusbyId(ID) {
    return httpbaseURL.httpMSInventoryUrl.post(
      "/AssetEscalation/UpdateStatus?ID=" + ID
    );
  }
  deletedata(doc) {
    return httpbaseURL.httpMSInventoryUrl.delete(
      "/AssetEscalation/Delete?ID=" + doc
    );
  }
}
export default new EscalationService();
